/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Event_OverlapInputs */



/**
* | output |
* | --- |
* | "Event overlaps with another event." |
*
* @param {Error_Nav_Event_OverlapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_overlap = /** @type {((inputs?: Error_Nav_Event_OverlapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_OverlapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'evenement se chevauche avec un autre evenement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Veranstaltung überschneidet sich mit einer anderen Veranstaltung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'evento si sovrappone a un altro evento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одно событие частично совпадает с другим событием.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento se superpone con otro evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件与其他事件重叠。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントが別のイベントと重複しています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह घटना किसी अन्य घटना के साथ ओवरलैप हो रही है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento coincide com outro evento.")
	return /** @type {LocalizedString} */ ("Event overlaps with another event.")
});